import { keys } from "lodash-es";

const VIEWPORTS: Record<string, number> = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  "x-lg": 1550
};

export function getViewport() {
  const { clientWidth } = document.documentElement;

  const width = clientWidth;

  const viewport = keys(VIEWPORTS).find((key) => {
    return width <= VIEWPORTS[key];
  });

  return viewport || "xx-lg";
}

export function isViewportLess(left: string, right: string): boolean {
  const leftWidth = VIEWPORTS[left] || Number.MAX_VALUE;
  const rightWidth = VIEWPORTS[right] || Number.MAX_VALUE;

  return leftWidth < rightWidth;
}
